import { cx } from "@emotion/css";
import type * as React from "react";
import * as styles from "./LegacyDataTableStyles";
interface LegacyDataTableProps {
    className?: string;
    title?: string;
    children?: React.ReactNode;
}
export function LegacyDataTable({ title, className, children }: LegacyDataTableProps): React.ReactElement {
    const titleAttr = title ? { ["aria-label"]: title } : null;
    return (<table {...titleAttr} className={cx(styles.dataTable, className)}>
            {children}
        </table>);
}
